module.exports = __webpack_public_path__ + "static/media/21_potolok_2.71_0.7484a35d.png";